<div class="media">
    <a [routerLink]="['/shop/navimart']">
        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'" 
             [lazyLoad]="ImageSrc ? ImageSrc : product.images[0].src"  
             class="img-fluid lazy-loading" alt="{{ product.images[0].alt }}">
    </a>
	<div class="media-body align-self-center">
		<!-- <div class="rating">
			<bar-rating [rate]="5" [readOnly]="true"></bar-rating>
		</div> -->
        <a [routerLink]="['/shop/navimart']">
            <h4>{{ product.title | titlecase }}</h4>
        </a>
		<h6 class="address">Kukatpally, 2 Km</h6>
        <div class="status">Open</div>
	</div>
</div>